import { useQuery } from '@tanstack/react-query'
import { api, type AnalyticsOverviewParams } from '@/lib/api-client'

/**
 * Fetch analytics overview data for the Analytics page
 * Includes KPIs, revenue trend, branch comparison, patient types, and top treatments
 */
export function useAnalyticsOverview(params?: AnalyticsOverviewParams) {
  return useQuery({
    queryKey: ['analytics-overview', params?.branchId, params?.startDate, params?.endDate, params?.compareWithPrevious],
    queryFn: () => api.analytics.overview(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
